// extracted by mini-css-extract-plugin
export default {"root":"QuoteSection__root--RyNPe","header":"QuoteSection__header--HwAfd","subtotal":"QuoteSection__subtotal--V1Bbv","items":"QuoteSection__items--QKony"};